import { authHeader } from './auth-header';
import axiosInstance from "./client"

export const machineTypeService = {
    getAllMachineType,
    createOrUpdate,
    getMachineTypeByID,
    deleteMachineByID,
};

function getMachineTypeByID(machineTypeId) {
    const requestOptions = {
        url : '/api/v1/user/machine_type/' + machineTypeId,
        method: 'GET',
        headers: authHeader()
    };
    return axiosInstance(requestOptions)
    //return fetch(`/api/v1/user/machine_type/` + machineTypeId, requestOptions).then(handleResponse);
}

function getAllMachineType() {
    // console.log(process.env)
    const requestOptions = {
        url : '/api/v1/user/machine_type',
        method: 'GET',
        headers: authHeader()
    };
    return axiosInstance( requestOptions)
}


function createOrUpdate(jsonData) {

    let formData = new FormData();

    for ( var key in jsonData ) {
        if (jsonData[key] != null)
            formData.append(key, jsonData[key]);
    }
    let rMethod = jsonData["id"] != null  ? "PUT" : "POST"
    const requestOptions = {
        url : '/api/v1/user/machine_type',
        method: rMethod,
        data: formData,
        headers: authHeader()
    };

    return axiosInstance(requestOptions);
}


function deleteMachineByID(machineId) {
    const requestOptions = {
        url: `/api/v1/user/machine_type/` + machineId,
        method: 'DELETE',
        headers: authHeader()
    };
    return axiosInstance(requestOptions);
}

